import { Col, Row } from 'react-bootstrap'
import TemplateCard from './TemplateCard'

const WebsiteTemplates = () => {
    const templates = [
        {
            id: 1,
            title: 'Template One',
            short_description: 'A short description about template one.',
            features: ['Feature 1', 'Feature 2', 'Feature 3'],
        },
        {
            id: 2,
            title: 'Template Two',
            short_description: 'A short description about template two.',
            features: ['Feature 1', 'Feature 2', 'Feature 3'],
        },
        {
            id: 3,
            title: 'Template Three',
            short_description: 'A short description about template three.',
            features: ['Feature 1', 'Feature 2', 'Feature 3'],
        },
    ]

    return (
        <Row>
            {templates.length > 0 ? (
                <>
                    {templates.map((template) => {
                        return (
                            <Col lg={6} xl={4} key={template.id}>
                                <TemplateCard template={template} />
                            </Col>
                        )
                    })}
                </>
            ) : (
                <Col></Col>
            )}
        </Row>
    )
}

export default WebsiteTemplates
